import React from "react";
import { Bgvideo1 } from "../common/Assetsmanger";
import { Link as ScrollLink } from 'react-scroll';
function Bannercom() {
  return (
    <div className="main-banner">
      <div className="video-section relative">
        <video
          className="w-full object-cover h-96 xl:h-screen"
          autoPlay
          loop
          muted
        >
          <source src={Bgvideo1} type="video/mp4"></source>
        </video>
        <div data-aos="fade-down" className="banner-content absolute text-center lg:text-start  top-0 w-full h-full flex justify-center items-center ps-0 lg:ps-28  lg:items-start flex-col ">
           <h1 className="text-stone-50 px-2 font-bold hidden lg:block lg:px-0">Digital Excellence | Web Developer</h1>
           <h1 className="text-stone-50 px-2 font-bold block lg:hidden lg:px-0">Digital Excellence <br/> Web Developer</h1>
           <p className="text-stone-50 pad-bottom px-2 px-2 lg:px-0">Crafting Seamless Digital Experiences
</p>
           <button className="text-stone-50 border-inherit border-2 rounded-sm px-2 py-2" > <ScrollLink to="targetComponent" offset={-50} smooth={true} duration={500}>
           Explore My Portfolio
      </ScrollLink></button>
        </div>
      </div>
    </div>
  );
}

export default Bannercom;
